
import React from 'react'
import Header from '../Integration/DashboardHeader'
import SideBarMenu from '../Integration/DashboardSideBarMenu'
import FormAddsProduto from '../Integration/FormAddsProduto'


function DashboardAddAdds() {
  return (

      <div className='dashboard-container'>
   
      <div className="homeheader">
        <Header/>

      </div>

     <div className="homebody">



      <div className="homeleft">

      <SideBarMenu/>

      </div>
      <div className="homeright">

        <div className="upright">

          <label></label>
        </div>
        <div className="downright">

        <FormAddsProduto/>
        </div>
        <div className='footageright'>


        </div>

      </div>
     </div>
        
        
        </div>
   
  )
}

export default DashboardAddAdds